'use strict';


import { getLoginRequiredResolveObj } from '../shared/utils/angularUtils';
import { NAVIGATION_ICON } from '../shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../shared/constants/user-info/solutionType';

export const reportsModule = angular
  .module('app.customerManagement', [])
  .config(reportsConfig);

reportsConfig.$inject = ['$routeProvider'];

function reportsConfig($routeProvider) {
  $routeProvider
    .when('/customer-self-setup', {
      template: '<ngz-customer-self-setup></ngz-customer-self-setup>',
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        hideNavigation: true,
      },
    })
    .when('/customer-self-setup/to-entity', {
      template: '<ngz-customer-self-setup-to-entity></ngz-customer-self-setup-to-entity>',
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        hideNavigation: true,
      },
    })
    .when('/customer-setup/flow-2024/:id', {
      template: '<ngz-customer-setup-flow-2024></ngz-customer-setup-flow-2024>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        breadcrumbs: [
          { label: 'Customer Setup', icon: NAVIGATION_ICON.PEOPLE_OUTLINE }
        ]
      }
    })
    .when('/user-profile', {
      template: '<ngz-user-profile></ngz-user-profile>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        breadcrumbs: [
          { label: 'User Profile', icon: NAVIGATION_ICON.PEOPLE_OUTLINE }
        ]
      }
    })
}
